const useDecode = (tokenName: string) => {
  const jwtDecode = require('jwt-decode');
  const token = localStorage.getItem(tokenName);
  if (token !== null) {
      const decoded = jwtDecode(token);
      return decoded;
  }
}

export default useDecode;